import { HTTP } from '../../http-common'

export default {
  state: {
    loadedRoofs: []
  },
  getters: {
    loadedRoofs (state) {
      return state.loadedRoofs
    }
  },
  mutations: {
    setLoadedRoofs (state, payload) {
      state.loadedRoofs = payload
    },
    createRoof (state, payload) {
      state.loadedRoofs.push(payload)
    },
    updateRoof (state, payload) {
      state.loadedRoofs = state.loadedRoofs.map(roof => roof.id === payload.id ? payload : roof)
    },
    removeRoof (state, id) {
      state.loadedRoofs = state.loadedRoofs.filter(roof => {
        return roof.id !== id
      })
    },
    clearLoadedRoofs (state) {
      state.loadedRoofs = []
    }
  },
  actions: {
    loadRoofs ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedRoofs', [])

      return new Promise((resolve, reject) => {
        HTTP.get('roof_type.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedRoofs', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createRoof ({ commit, getters }, payload) {
      console.log('createRoof')
      commit('clearError')
      commit('setLoading', true)
      const newRoof = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.post('roof_type.json/', newRoof)
          .then(result => {
            console.log(result)
            commit('createRoof', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateRoof ({ commit, getters }, payload) {
      console.log('updateRoof')
      commit('clearError')
      commit('setLoading', true)
      const roof = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`roof_type.json/${payload.id}/`, roof)
          .then(result => {
            console.log(result)
            commit('updateRoof', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeRoof ({ commit }, payload) {
      console.log('removeRoof')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`roof_type.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeRoof', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedRoofs ({ commit }) {
      commit('clearLoadedRoofs')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/roof/index.js